import { combineReducers } from 'redux';
import { createReducer } from '@reduxjs/toolkit';
import {
	addContactRequest,
	addContactSuccess,
	addContactError,
	deleteContactRequest,
	deleteContactSuccess,
	deleteContactError,
	changeFilter,
	// toggleCompletedRequest,
	// toggleCompletedSuccess,
	// toggleCompletedError,
	fetchContactsRequest,
	fetchContactsSuccess,
	fetchContactsError,
} from './contactsActions';

const items = createReducer([], {
	[fetchContactsSuccess]: (_, { payload }) => payload,
	[addContactSuccess]: (state, { payload }) => [payload, ...state],
	[deleteContactSuccess]: (state, { payload }) =>
		state.filter(({ id }) => id !== payload),
	// [toggleCompletedSuccess]: (state, { payload }) =>
	// 	state.map(contact => (contact.id === payload.id ? payload : contact)),
});

const loading = createReducer(false, {
	[fetchContactsRequest]: () => true,
	[fetchContactsSuccess]: () => false,
	[fetchContactsError]: () => false,
	[addContactRequest]: () => true,
	[addContactSuccess]: () => false,
	[addContactError]: () => false,
	[deleteContactRequest]: () => true,
	[deleteContactSuccess]: () => false,
	[deleteContactError]: () => false,
	// [toggleCompletedRequest]: () => true,
	// [toggleCompletedSuccess]: () => false,
	// [toggleCompletedError]: () => false,
});

const filter = createReducer('', {
	[changeFilter]: (_, { payload }) => payload,
});

const error = createReducer(null, {});

export default combineReducers({
	items,
	filter,
	loading,
	error,
});